import { Plugin } from '@tiptap/pm/state';
import { type Editor, Extension, InputRule } from '@tiptap/react';
import { capitalizeSentenceStart } from '@/utils/text';

export const Capitalize = Extension.create({
  name: 'capitalize',

  addInputRules() {
    return [
      new InputRule({
        find: (text) =>
          capitalizeSentenceStart(text) === text
            ? null
            : { index: text.length - 1, text: text.slice(-1) },
        handler: ({ state, range, match }) => {
          state.tr.insertText(match[0].toUpperCase(), range.from, range.to);
        },
      }),
    ];
  },

  addProseMirrorPlugins() {
    return [
      new Plugin({
        props: { attributes: { autocapitalize: 'sentences' } },
      }),
    ];
  },
});

export const getSelectedText = (editor: Editor): string => {
  const { from, to } = editor.state.selection;

  return editor.state.doc.textBetween(from, to);
};

export const applyLink = (editor: Editor, href: string, text: string): void => {
  const trimmedHref = href.trim();

  if (trimmedHref === '') {
    editor.chain().focus().extendMarkRange('link').unsetLink().run();
    return;
  }

  const chain = editor.chain().focus();

  if (editor.isActive('link')) {
    chain.extendMarkRange('link');
  }

  chain
    .insertContent({
      type: 'text',
      text: text.trim() === '' ? trimmedHref : text,
      marks: [{ type: 'link', attrs: { href: trimmedHref } }],
    })
    .run();
};
